var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllStains(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "52px",
    viewBox: "0 0 82 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-describedby": "all-stains-title all-stains-desc",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "all-stains-title"
  }, "All Stains") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "all-stains-title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "all-stains-desc"
  }, "Umbrellas protecting your purchase")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CLY_IconFamily_v2-copy",
    transform: "translate(-222.000000, -335.000000)",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(223.823400, 335.383600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5851,12.0809 L38.5851,8.9419",
    id: "Stroke-75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.862,47.0595 C44.862,48.7925 43.457,50.1985 41.724,50.1985 C39.99,50.1985 38.585,48.7925 38.585,47.0595 L38.585,31.5835",
    id: "Stroke-76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1036,27.0136 C30.2126,27.0136 32.0966,27.9636 33.3606,29.4556 C34.6246,27.9636 36.5086,27.0136 38.6166,27.0136 C40.7256,27.0136 42.6096,27.9636 43.8736,29.4556 C45.1376,27.9636 47.0216,27.0136 49.1296,27.0136 C51.1796,27.0136 53.0156,27.9136 54.2766,29.3346 L54.2766,27.7726 C54.2766,19.1056 47.2516,12.0806 38.5846,12.0806 C29.9186,12.0806 22.8936,19.1056 22.8936,27.7726 L22.8936,29.4046 C24.1566,27.9426 26.0206,27.0136 28.1036,27.0136 Z",
    id: "Stroke-77",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6915,3.139 L15.6915,0",
    id: "Stroke-78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9684,38.1176 C21.9684,39.8506 20.5634,41.2566 18.8304,41.2566 C17.0964,41.2566 15.6914,39.8506 15.6914,38.1176 L15.6914,22.6416",
    id: "Stroke-79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.297,9.4838 C25.438,5.6338 20.856,3.1388 15.692,3.1388 C7.025,3.1388 1.24344979e-14,10.1638 1.24344979e-14,18.8308 L1.24344979e-14,20.4628 C1.263,19.0008 3.127,18.0718 5.21,18.0718 C7.319,18.0718 9.203,19.0218 10.467,20.5138 C11.731,19.0218 13.615,18.0718 15.723,18.0718 C17.832,18.0718 19.716,19.0218 20.98,20.5138",
    id: "Stroke-80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6925,3.139 L62.6925,0",
    id: "Stroke-81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9694,38.1176 C68.9694,39.8506 67.5644,41.2566 65.8304,41.2566 C64.0974,41.2566 62.6924,39.8506 62.6924,38.1176 L62.6924,22.6416",
    id: "Stroke-82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4674,20.5136 C58.7314,19.0216 60.6154,18.0716 62.7244,18.0716 C64.8324,18.0716 66.7174,19.0216 67.9804,20.5136 C69.2444,19.0216 71.1294,18.0716 73.2374,18.0716 C75.2874,18.0716 77.1224,18.9716 78.3844,20.3926 L78.3844,18.8306 C78.3844,10.1636 71.3594,3.1386 62.6924,3.1386 C57.4154,3.1386 52.7474,5.7426 49.9034,9.7366",
    id: "Stroke-83",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllStains);
export default __webpack_public_path__ + "static/media/all-stains.5639bba451861e79bf164dc4803ce1c8.svg";
export { ForwardRef as ReactComponent };